import React, { FC, ReactNode, useEffect, useState } from 'react';
import { BlogType, CreateBlogFormType } from 'models/blog';
import { handleApiError } from 'utils/functions';
import { apiService } from 'services/base.service';
import { useSearchParams } from 'react-router-dom';
import { CreateBlogContext } from './context';

const CreateBlogProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const blogId = searchParams.get('blog_id');
  const [createBlogForm, setCreateBlogForm] = useState<CreateBlogFormType>({
    title: '',
    body: '',
    image: '',
    tags: [],
    is_draft: false,
    pinPost: false
  });
  const [disabled, setDisabled] = useState(true);
  const [wordsCount, setWordsCount] = useState(0);

  const getBlogById = async () => {
    if (!blogId) return;
    try {
      const res = await apiService.get<BlogType>(`blog/${blogId}`);
      const { title, body, image, tags, is_draft, pinned } = res.data;
      setCreateBlogForm({
        title,
        body,
        image,
        tags,
        is_draft,
        pinPost: pinned
      });
    } catch (err: any) {
      handleApiError(err);
    }
  };

  useEffect(() => {
    getBlogById();
  }, [blogId]);

  return (
    <CreateBlogContext.Provider
      value={{
        createBlogForm,
        setCreateBlogForm,
        disabled,
        setDisabled,
        wordsCount,
        setWordsCount
      }}>
      {children}
    </CreateBlogContext.Provider>
  );
};

export default CreateBlogProvider;
